import {CreateProps} from "react-admin";
import {BankReceiptForm} from "./BankReceiptForm";
import {CustomCreate} from "../../components/CustomCreate";

export const BankReceiptCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props}>
      <BankReceiptForm />
    </CustomCreate>
  );
};
